/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgreementsControllerFindVersionsByTypeQueryResponse, AgreementsControllerFindVersionsByTypePathParams, AgreementsControllerFindVersionsByType401 } from "../../models/agreementsController/AgreementsControllerFindVersionsByType";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { agreementsControllerFindVersionsByType } from "../../clients/agreementsService/agreementsControllerFindVersionsByType";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const agreementsControllerFindVersionsByTypeQueryKey = (type: AgreementsControllerFindVersionsByTypePathParams["type"]) => [{
  url: '/api/v1/agreements/:type/versions',
  params: {
    type: type
  }
}] as const;
export type AgreementsControllerFindVersionsByTypeQueryKey = ReturnType<typeof agreementsControllerFindVersionsByTypeQueryKey>;
export function agreementsControllerFindVersionsByTypeQueryOptions(type: AgreementsControllerFindVersionsByTypePathParams["type"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = agreementsControllerFindVersionsByTypeQueryKey(type);
  return queryOptions<AgreementsControllerFindVersionsByTypeQueryResponse, ResponseErrorConfig<AgreementsControllerFindVersionsByType401>, AgreementsControllerFindVersionsByTypeQueryResponse, typeof queryKey>({
    enabled: !!type,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return agreementsControllerFindVersionsByType(type, config);
    }
  });
}

/**
 * @summary Get all versions of an agreement
 * {@link /api/v1/agreements/:type/versions}
 */
export function useAgreementsControllerFindVersionsByType<TData = AgreementsControllerFindVersionsByTypeQueryResponse, TQueryData = AgreementsControllerFindVersionsByTypeQueryResponse, TQueryKey extends QueryKey = AgreementsControllerFindVersionsByTypeQueryKey>(type: AgreementsControllerFindVersionsByTypePathParams["type"], options: {
  query?: Partial<QueryObserverOptions<AgreementsControllerFindVersionsByTypeQueryResponse, ResponseErrorConfig<AgreementsControllerFindVersionsByType401>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? agreementsControllerFindVersionsByTypeQueryKey(type);
  const query = useQuery({
    ...agreementsControllerFindVersionsByTypeQueryOptions(type, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AgreementsControllerFindVersionsByType401>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}